import { iconSize, IconSizeProps } from '@/types/icons';

export const IconReports = ({ size }: IconSizeProps) => {
  return (
    <svg
      fill="currentColor"
      className={iconSize[size]}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path
        d="M5 21L19 21C20.1046 21 21 20.1046 21 19L21 5C21 3.89543 20.1046 3 19 3L5 3C3.89543 3 3 3.89543 3 5L3 19C3 20.1046 3.89543 21 5 21Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14 17L17 17L17 8L14 8L14 17Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 17L10 17L10 12L7 12L7 17Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
